// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"6fa0ce95","200":"bb81713b","235":"d4bd5829","263":"b27958dd","453":"c70883a4","677":"b46ac8b4"}[chunkId] + ".chunk.js";
};